import React, { useState } from 'react';
import { usePWA } from '@/hooks/usePWA';
import { cn } from '@/lib/utils';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

export const OfflineIndicator: React.FC = () => {
  const { connectionStatus, recheckConnection } = usePWA();
  const [isChecking, setIsChecking] = useState(false);

  const handleRecheck = async () => {
    setIsChecking(true);
    await recheckConnection();
    setTimeout(() => setIsChecking(false), 1000);
  };

  const dotColors = {
    online: 'bg-green-500',
    offline: 'bg-orange-500',
    uncertain: 'bg-yellow-500',
    checking: 'bg-blue-500'
  };

  const statusText = {
    online: 'Online',
    offline: 'Offline',
    uncertain: 'Connection Uncertain',
    checking: 'Checking...'
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            onClick={handleRecheck}
            disabled={isChecking}
            className="fixed top-20 right-4 z-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary rounded-full p-1 transition-transform hover:scale-110"
            aria-label={`Connection status: ${statusText[connectionStatus]}. Click to recheck.`}
          >
            <div 
              className={cn(
                "w-2.5 h-2.5 rounded-full transition-all",
                dotColors[connectionStatus],
                connectionStatus === 'checking' && "animate-pulse scale-125"
              )} 
            />
          </button>
        </TooltipTrigger>
        <TooltipContent side="left" className="font-medium">
          <p>{statusText[connectionStatus]}</p>
          {connectionStatus !== 'checking' && (
            <p className="text-xs text-muted-foreground mt-0.5">Click to recheck</p>
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};